import React from 'react';
import Header from '../Header/Header';

const Blogs = () => {
    return (
        <div>
            <h1 className="text-center text-success">Coming Soon</h1>
        </div>
    );
};

export default Blogs;